import { render, staticRenderFns } from "./agricult_product_show.vue?vue&type=template&id=7c071cb7&"
import script from "./agricult_product_show.vue?vue&type=script&lang=js&"
export * from "./agricult_product_show.vue?vue&type=script&lang=js&"
import style0 from "./agricult_product_show.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports